import T from "./types";

export const setIsHiddenMobileButton = (isHiddenMobileButton) => ({
  type: T.SET_IS_SHOW_BUTTON,
  isHiddenMobileButton,
});
